import React from 'react';
import { useIntl } from 'react-intl';

export const intlHOC = (Component: any) => {
  /* eslint-disable react/display-name */
  return (props: any) => {
    const intl = useIntl();

    return <Component intl={intl} {...props} />;
  };
};
